export default __webpack_public_path__ + "static/media/Vidste_du_Flæskesteg.baee207d.mp4";